import { render, staticRenderFns } from "./CompanySelectOnboarding.vue?vue&type=template&id=0788a010&scoped=true&"
import script from "./CompanySelectOnboarding.vue?vue&type=script&lang=js&"
export * from "./CompanySelectOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./CompanySelectOnboarding.vue?vue&type=style&index=0&id=0788a010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788a010",
  null
  
)

export default component.exports